import Box from '@mui/material/Box'
import MUITooltip, { TooltipProps } from '@mui/material/Tooltip'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

import TooltipIcon from './Icons/Tooltip.svg?react'

export const CustomTooltip = (
  props: Omit<TooltipProps, 'children'> & {
    children?: TooltipProps['children']
    iconProps?: React.SVGProps<SVGSVGElement> & {
      title?: string
      titleId?: string
      desc?: string
      descId?: string
    }
  },
) => {
  const { iconProps, children, ...tooltipProps } = props
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  return (
    <MUITooltip
      arrow
      enterTouchDelay={50}
      leaveTouchDelay={2500}
      placement={isSmallScreen ? 'top' : 'right'}
      {...tooltipProps}
    >
      {children ?? (
        <Box
          data-cy="tooltip-icon"
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0px',
          }}
        >
          <TooltipIcon width={16} height={16} {...iconProps} />
        </Box>
      )}
    </MUITooltip>
  )
}

export const Tooltip = CustomTooltip // TO-DO: Remove "CustomTooltip" export and replace with "Tooltip" across the codebase

export default CustomTooltip
